var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "section-invert reverse-sm",
      attrs: { id: "security-data" }
    },
    [
      _c("b-col", { attrs: { md: "12", lg: "6" } }, [
        _c("div", { staticClass: "col-bg ml-lg-auto" })
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "content my-auto", attrs: { md: "12", lg: "6" } },
        [
          _c("h3", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.$t("abogalitypro.security-privacity.blackTitle")))
          ]),
          _vm._v(" "),
          _c("h3", { staticStyle: { "font-size": "30px" } }, [
            _vm._v(_vm._s(_vm.$t("abogalitypro.security-privacity.title")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("abogalitypro.security-privacity.text")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$t("abogalitypro.security-privacity.text2")))
            ])
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            {
              staticClass: "cert-icons mt-5",
              staticStyle: { display: "inline-block" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "mr-5",
                  staticStyle: { display: "inline-block" }
                },
                [_c("ISO27001Logo")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { display: "inline-block" } }, [
                _c("img", {
                  staticClass: "vertical",
                  attrs: {
                    src:
                      "/static-appopensalud/img/icons/morillas-svg-icons/Logo/iso.png"
                  }
                })
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc2f9942", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc2f9942","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/abogalitypro/AbogalitySecurityPrivacityBlock.vue
// module id = 4112
// module chunks = 10